export default __webpack_public_path__ + "static/media/ic_lif3_24.08d37721.svg";